import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children,validRole  }) => {
  const {token,user:{role}} = useSelector((state) => state.auth);
  // const role = user.role || null; // Get the role from the user object
  return token && validRole.includes(role) ? children : <Navigate to="/login" />;
};

export default PrivateRoute;